import axiosInstance from "./instance";

const instance = axiosInstance();
export const createTheDeal = async (data) => {
    try {
        const response = await instance.post(`/deals`,data);
        return response;
    } catch (error) {
        return error;
    }
}
export const updateTheDeal = async (id,data) => {
    try {
        const response = await instance.put(`/deals/${id}`,data);
        return response;
    } catch (error) {
        return error;
    }
}
export const searchTheDeal = async (page,size,data) => {
    try {
        const response = await instance.post(`/deals/search?page=${page}&size=${size}`,data);
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllDeals = async (page,size) => {
    try {
        const response = await instance.get(`/deals?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const getDealsOnStatus = async (status,page,size) => {
    try {
        const response = await instance.get(`/deals/status/${status}?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}
